/**
 * 통화 표기 목록. 백엔드 ``VALUE_CURRENCY_TOKENS`` 와 같은 값이다. 목록에 없는 표기는 금액으로
 * 보지 않으므로 "IAS 36" 처럼 코드 꼴만 닮은 값은 걸리지 않는다.
 */
const CURRENCY_TOKENS = [
  "$",
  "AED",
  "AFN",
  "ALL",
  "AMD",
  "ANG",
  "AOA",
  "ARS",
  "AUD",
  "AWG",
  "AZN",
  "BAM",
  "BBD",
  "BDT",
  "BGN",
  "BHD",
  "BIF",
  "BMD",
  "BND",
  "BOB",
  "BOV",
  "BRL",
  "BSD",
  "BTN",
  "BWP",
  "BYN",
  "BZD",
  "CAD",
  "CDF",
  "CHE",
  "CHF",
  "CHW",
  "CLF",
  "CLP",
  "CNH",
  "CNY",
  "COP",
  "COU",
  "CRC",
  "CUC",
  "CUP",
  "CVE",
  "CZK",
  "DJF",
  "DKK",
  "DOP",
  "DZD",
  "EGP",
  "ERN",
  "ETB",
  "EUR",
  "FJD",
  "FKP",
  "GBP",
  "GEL",
  "GHS",
  "GIP",
  "GMD",
  "GNF",
  "GTQ",
  "GYD",
  "HKD",
  "HNL",
  "HRK",
  "HTG",
  "HUF",
  "IDR",
  "ILS",
  "INR",
  "IQD",
  "IRR",
  "ISK",
  "JMD",
  "JOD",
  "JPY",
  "KES",
  "KGS",
  "KHR",
  "KMF",
  "KPW",
  "KRW",
  "KWD",
  "KYD",
  "KZT",
  "LAK",
  "LBP",
  "LKR",
  "LRD",
  "LSL",
  "LYD",
  "MAD",
  "MDL",
  "MGA",
  "MKD",
  "MMK",
  "MNT",
  "MOP",
  "MRU",
  "MUR",
  "MVR",
  "MWK",
  "MXN",
  "MXV",
  "MYR",
  "MZN",
  "NAD",
  "NGN",
  "NIO",
  "NOK",
  "NPR",
  "NTD",
  "NZD",
  "OMR",
  "PAB",
  "PEN",
  "PGK",
  "PHP",
  "PKR",
  "PLN",
  "PYG",
  "QAR",
  "RMB",
  "RON",
  "RP",
  "RSD",
  "RUB",
  "RWF",
  "SAR",
  "SBD",
  "SCR",
  "SDG",
  "SEK",
  "SGD",
  "SHP",
  "SLE",
  "SLL",
  "SOS",
  "SRD",
  "SSP",
  "STN",
  "SVC",
  "SYP",
  "SZL",
  "THB",
  "TJS",
  "TMT",
  "TND",
  "TOP",
  "TRY",
  "TTD",
  "TWD",
  "TZS",
  "UAH",
  "UGX",
  "USD",
  "USN",
  "UYI",
  "UYU",
  "UZS",
  "VED",
  "VEF",
  "VES",
  "VND",
  "VUV",
  "WST",
  "XAF",
  "XAG",
  "XAU",
  "XCD",
  "XCG",
  "XDR",
  "XOF",
  "XPD",
  "XPF",
  "XPT",
  "XSU",
  "XTS",
  "XUA",
  "XXX",
  "YER",
  "ZAR",
  "ZMW",
  "ZWG",
  "ZWL",
  "\\",
  "£",
  "¥",
  "₩",
  "€",
  "달러",
  "달러화",
  "대만달러",
  "대만달러화",
  "미국달러",
  "미국달러화",
  "불",
  "스위스프랑",
  "스위스프랑화",
  "싱가포르달러",
  "싱가포르달러화",
  "엔",
  "엔화",
  "영국파운드",
  "영국파운드화",
  "원화",
  "위안",
  "위안화",
  "유럽유로",
  "유럽유로화",
  "유로",
  "유로화",
  "일본엔",
  "일본엔화",
  "중국위안",
  "중국위안화",
  "캐나다달러",
  "캐나다달러화",
  "파운드",
  "프랑",
  "호주달러",
  "호주달러화",
  "홍콩달러",
  "홍콩달러화",
  "￦",
];

const escapeRegExp = (text: string): string =>
  text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const TOKEN = CURRENCY_TOKENS.map(escapeRegExp).join("|");
const NUMBER = "\\d[\\d,.]*";
/** 배율 표기. 백엔드 ``_CURRENCY_MULTIPLIER`` 와 같다(영문은 공시에 쓰이는 대소문자만 받는다). */
const MULTIPLIER =
  "(?:\\s*(?:조|억|천만|백만|십만|만|천|백|십|[Tt]housand|[Mm]illion|[Bb]illion|[Mm]il|[Bb]n|THOUSAND|MILLION|BILLION|MIL|BN))?";
const FOREIGN_AMOUNT = new RegExp(
  `^(?:${TOKEN})\\s*${NUMBER}${MULTIPLIER}$|^${NUMBER}${MULTIPLIER}\\s*(?:${TOKEN})$`,
);

/**
 * 값 전체가 통화가 적힌 금액인가.
 *
 * 값 전체를 보는 이유: 문단 전체도 값으로 오므로 앞만 보면 "USD 기준으로 …" 도 금액이 된다.
 */
export const isCurrencyAmount = (value: string): boolean =>
  /원$/.test(value) || FOREIGN_AMOUNT.test(value);
